const Flash = {
  timeoutTimer: 4000,
  mounted() {
    this.timers = new Map();
    this.handleFlashMessages();
  },
  handleFlashMessages() {
    let flashMessages = this.el.querySelectorAll(".flash-message[phx-click]");
    flashMessages.forEach((flashMessage) => {
      let hide = () => {
        if (this.el.classList.contains("hidden")) {
          return;
        }
        let phxClickAttr = flashMessage.getAttribute("phx-click");
        if (phxClickAttr) {

          liveSocket.execJS(flashMessage, phxClickAttr);
        } else {
          // Simulate a click event if no phx-click attribute was found
          flashMessage.click();
        }
      };

      let mainTimer = setTimeout(() => hide(), this.timeoutTimer);
      this.timers.set(flashMessage, mainTimer);

      flashMessage.addEventListener("phx:hide-start", () => {
        clearTimeout(this.timers.get(flashMessage));
      });
      flashMessage.addEventListener("mouseover", () => {
        clearTimeout(this.timers.get(flashMessage));
        mainTimer = setTimeout(() => hide(), this.timeoutTimer);
        this.timers.set(flashMessage, mainTimer);
      });
    });
  },
  destroyed() {
    let flashMessages = this.el.querySelectorAll(".flash-message[phx-click]");
    flashMessages.forEach((flashMessage) => {
      flashMessage.classList.add("hidden");
      clearTimeout(this.timers.get(flashMessage));
    });
  },
};

export default Flash;
